<template>
<div class="wrapper">

  <!-- content-box -->
  <div class="content-box">
    <div class="content-inner">
      <h2 class="h2">com.waze</h2>
      <span class="chart-title">Quality Trend Chart</span>
      <span class="chart-caption">Click on any of the bars to get directed to the Issues Report page of the application.</span>

      <h3 class="chart-subtitle">ANR and FC Statistics per Application Version</h3>
      <div class="chart-wrap">
        <div class="chart-inner">
          <div class="chart">
            <div class="chart-img"><img src="/images/chart/chart3.png" alt=""></div>
          </div>
        </div>
      </div>

      <h3 class="chart-subtitle">ANR and FC Statistics per Samsung Model</h3>
      <div class="chart-wrap">
        <div class="chart-inner">
          <div class="chart">
            <div class="chart-img"><img src="/images/chart/chart4.png" alt=""></div>
          </div>
        </div>
      </div>
      <div class="tableWrap">
        <div class="titArea">
          <h3 class="tit">Issues Summary</h3>
        </div>
        <div class="right-wrap">
          <div class="check-wrap">
            <input type="checkbox" name="checkbox" id="checkbox">
            <label for="checkbox">
              <span>Model Grouping</span>
            </label>
          </div>
          <button class="filled-btn" type="button" id="createBtn">Create Issue</button>
        </div>

        <div class="innerTable summary group-out" style="display:block;">
          <div class="scrollX">
            <div class="tableSt01">
              <table>
                <colgroup>
                  <col width="120px" />
                  <col width="120px" />
                  <col width="120px" />
                  <col width="120px" />
                  <col width="120px" />
                  <col width="120px" />
                  <col width="120px" />
                  <col width="*" />
                </colgroup>
                <thead>
                  <tr class="only">
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>App Version</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>FC/ANR</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Touch</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Sluggish</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Battery<br/>Consumption</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Function</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Foldable</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>All</strong>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
              </table>
              <div class="">
                <div class="tableSt01">
                  <table>
                    <colgroup>
                      <col width="120px" />
                      <col width="120px" />
                      <col width="120px" />
                      <col width="120px" />
                      <col width="120px" />
                      <col width="120px" />
                      <col width="120px" />
                      <col width="*" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td class="center">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>12</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>12</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>12</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>12</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>12</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>12</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>12</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>12</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>12</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>12</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>      
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="innerTable summary group-in" style="display:none;">
          <div class="scrollX">
            <div class="tableSt01">
              <table>
                <colgroup>
                  <col width="96px" />
                  <col width="96px" />
                  <col width="76px" />
                  <col width="96px" />
                  <col width="76px" />
                  <col width="76px" />
                  <col width="96px" />
                  <col width="120px" />
                  <col width="96px" />
                  <col width="96px" />
                  <col width="*" />
                </colgroup>
                <thead>
                  <tr class="only">
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>App Version</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Model Name</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>OS</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Model Version</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>FC/ANR</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Touch</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Sluggish</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Battery<br/>Consumption</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Function</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>Foldable</strong>
                        </div>
                      </div>
                    </th>
                    <th class="center">
                      <div class="inbox">
                        <div class="str">
                          <strong>All</strong>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
              </table>
              <div class="">
                <div class="tableSt01 modal">
                  <table>
                    <colgroup>
                       <col width="96px" />
                        <col width="96px" />
                        <col width="76px" />
                        <col width="96px" />
                        <col width="76px" />
                        <col width="76px" />
                        <col width="96px" />
                        <col width="120px" />
                        <col width="96px" />
                        <col width="96px" />
                        <col width="*" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td class="center appVer01" rowspan="2" dtr-row="2">
                          <div><p>1.2.2</p></div>
                        </td>
                        <td class="center">
                          <div><p>A305N</p></div>
                        </td>
                        <td class="center">
                          <div><p>11</p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="openr" data-tr="2" data-target="appVer01"><img src="/images/icon_openr_off.png" alt=""></button></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="center">
                          <div><p>XXXTB1</p></div>
                        </td>
                        <td class="center">
                          <div><p>55</p></div>
                        </td>
                        <td class="center">
                          <div><p>37</p></div>
                        </td>
                        <td class="center">
                          <div><p>4</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="center">
                          <div><p>XXXTB1</p></div>
                        </td>
                        <td class="center">
                          <div><p>55</p></div>
                        </td>
                        <td class="center">
                          <div><p>37</p></div>
                        </td>
                        <td class="center">
                          <div><p>4</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>A305N</p></div>
                        </td>
                        <td class="center">
                          <div><p>11</p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="openr" data-tr="1" data-target="appVer01"><img src="/images/icon_openr_off.png" alt=""></button></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="center">
                          <div><p>XXXTB1</p></div>
                        </td>
                        <td class="center">
                          <div><p>55</p></div>
                        </td>
                        <td class="center">
                          <div><p>37</p></div>
                        </td>
                        <td class="center">
                          <div><p>4</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center appVer02" rowspan="2" dtr-row="2">
                          <div><p>1.2.1</p></div>
                        </td>
                        <td class="center">
                          <div><p>A305N</p></div>
                        </td>
                        <td class="center">
                          <div><p>11</p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="openr" data-tr="2" data-target="appVer02"><img src="/images/icon_openr_off.png" alt=""></button></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="center">
                          <div><p>XXXTB1</p></div>
                        </td>
                        <td class="center">
                          <div><p>55</p></div>
                        </td>
                        <td class="center">
                          <div><p>37</p></div>
                        </td>
                        <td class="center">
                          <div><p>4</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="center">
                          <div><p>XXXTB1</p></div>
                        </td>
                        <td class="center">
                          <div><p>55</p></div>
                        </td>
                        <td class="center">
                          <div><p>37</p></div>
                        </td>
                        <td class="center">
                          <div><p>4</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="center">
                          <div><p>A305N</p></div>
                        </td>
                        <td class="center">
                          <div><p>11</p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="openr" data-tr="2" data-target="appVer02"><img src="/images/icon_openr_off.png" alt=""></button></div>
                        </td>
                        <td class="center">
                          <div><p>97</p></div>
                        </td>
                        <td class="center">
                          <div><p>78</p></div>
                        </td>
                        <td class="center">
                          <div><p>5</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="center">
                          <div><p>XXXTB1</p></div>
                        </td>
                        <td class="center">
                          <div><p>55</p></div>
                        </td>
                        <td class="center">
                          <div><p>37</p></div>
                        </td>
                        <td class="center">
                          <div><p>4</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="blue">
                          <div><p></p></div>
                        </td>
                        <td class="center">
                          <div><p>XXXTB1</p></div>
                        </td>
                        <td class="center">
                          <div><p>55</p></div>
                        </td>
                        <td class="center">
                          <div><p>37</p></div>
                        </td>
                        <td class="center">
                          <div><p>4</p></div>
                        </td>
                        <td class="center">
                          <div><p>10</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                        <td class="center">
                          <div><p>2</p></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>      
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="infoTable">
          <span>Rows per page :</span>
          <div class="selects type03">
            <button type="button" class="off">10</button>
            <ul>
              <li><button type="button">10</button></li>
            </ul>
          </div>
          <span>1-5 of 999</span>
          <div class="btns">
            <button type="button" class="prev"><img src="/images/arrow.png" alt=""></button>
            <button type="button"><img src="/images/arrow.png" alt=""></button>
          </div>
        </div>
      </div>
      
      <div class="sortable-table">
        <!-- samsung user case -->
        <div class="tableWrap">
          <div class="titArea">
            <h3 class="tit">Detail Information</h3>
            <div class="table-filter">
              <div class="filter-item short">
                <span class="title">Search by</span>
                <a href="#;" class="selected-text"><span>All</span></a>
                <!-- 토글 시 .active 클래스 추가 -->
                <div class="dropdown-wrap">
                  <ul>
                    <li><a href="#;">All</a></li>
                    <li><a href="#;">Issue No.</a></li>
                    <li><a href="#;">PLM No.</a></li>
                    <li><a href="#;">App Version</a></li>
                    <li><a href="#;">OS</a></li>
                    <li><a href="#;">Report and Guide</a></li>
                    <li><a href="#;">Symptom</a></li>
                    <li><a href="#;">Last Comment</a></li>
                    <li><a href="#;">Last Modified</a></li>
                  </ul>
                </div>
              </div>
              <div class="filter-item">
                <span class="title">Search</span>
                <div class="input-text search">
                  <input type="text" name="" id="" value="" placeholder="Search"><button type="button"><img src="/images/btn_close.png" alt=""></button>
                </div>
              </div>
              <div class="alignRight">
                <div class="filter-item">
                  <span class="title">Last Modified</span>
                  <div class="picker-wrap">
                    <date-picker :editable="false" v-model="time1" type="date" range :format="format" @change="toggleFooter" @open="open" @close="close" ref="datepicker" :lang="lang" placeholder="Select Datetime">
                      <template v-slot:header="{ emit }">
                        <button class="mx-btn mx-btn-text" @click="selectPrev7Day(emit)">Previous 7 Days</button>
                        <button class="mx-btn mx-btn-text" @click="selectPrev30Day(emit)">Previous 30 Days</button>
                        <button class="mx-btn mx-btn-text" @click="selectPrev60Day(emit)">Previous 60 Days</button>
                        <button class="mx-btn mx-btn-text" @click="selectPrev90Day(emit)">Previous 90 Days</button>
                      </template>
                      <template v-slot:footer="{  }">
                        <button class="mx-btn mx-btn-text" @click="handleApply">OK</button>
                      </template>
                      <i slot="icon-clear"><span class="clear-icon"><img src="/images/btn_close.png" alt=""></span></i>
                    </date-picker>
                  </div>
                </div>
                <button type="button" class="excel" data-pop="excel-pop">Export</button>
                <button type="button" class="column" data-pop="column-pop">Columns</button>
              </div>
            </div>
          </div>
          <div class="innerTable with-filter">
            <div class="scrollX">
              <div class="tableSt01">
                <table class="absolute">
                  <colgroup>
                    <col width="124px" />
                    <col width="96px" />
                    <col width="96px" />
                    <col width="96px" />
                    <col width="96px" />
                    <col width="80px" />
                    <col width="190px" />
                    <col width="128px" />
                    <col width="140px" />
                    <col width="210px" />
                    <col width="128px" />
                    <col width="128px" />
                    <col width="40px" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Issue No.</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>PLM No.</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>App Version</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Model Name</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Model Version</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>OS</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Report and Guide</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Symptom</strong>
                            <div class="filter">
                              <button type="button"><span class="sr-only">filter</span></button>
                              <div class="dropdown-wrap">
                                <ul>
                                  <li><a href="#;">All</a></li>
                                  <li><a href="#;">FC/ANR</a></li>
                                  <li><a href="#;">Touch</a></li>
                                  <li><a href="#;">Sluggish</a></li>
                                  <li><a href="#;">Battery Consumption</a></li>
                                  <li><a href="#;">Function</a></li>
                                  <li><a href="#;">Foldable</a></li>
                                </ul>
                              </div>
                            </div>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Reported by</strong>
                            <div class="filter">
                              <button type="button"><span class="sr-only">filter</span></button>
                              <div class="dropdown-wrap">
                                <ul>
                                  <li><a href="#;">All</a></li>
                                  <li><a href="#;">App</a></li>
                                  <li><a href="#;">Me</a></li>
                                  <li><a href="#;">Samsung</a></li>
                                </ul>
                              </div>
                            </div>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Reported by (id)</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Last Comment</strong>
                            <div class="filter">
                              <button type="button"><span class="sr-only">filter</span></button>
                              <div class="dropdown-wrap">
                                <ul>
                                  <li><a href="#;">All</a></li>
                                  <li><a href="#;">App</a></li>
                                  <li><a href="#;">Samsung</a></li>
                                </ul>
                              </div>
                            </div>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Last Modified</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th class="file">
                        <div class="inbox">
                          <div class="str">
                            <strong>File</strong>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </table>
                <div class="scroll">
                  <table>
                    <colgroup>
                      <col width="124px" />
                      <col width="96px" />
                      <col width="96px" />
                      <col width="96px" />
                      <col width="96px" />
                      <col width="80px" />
                      <col width="190px" />
                      <col width="128px" />
                      <col width="140px" />
                      <col width="210px" />
                      <col width="128px" />
                      <col width="128px" />
                      <col width="40px" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p><a href="#">P2020215</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt="">09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), …</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="13" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <!-- <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p><a href="#">P2020215</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="13" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p><a href="#">P2020215</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="13" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p><a href="#">P2020215</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="13" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p><a href="#">P2020215</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="13" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p><a href="#">P2020215</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="13" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p><a href="#">P2020215</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="13" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p><a href="#">P2020215</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="13" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p><a href="#">P2020215</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="13" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p><a href="#">P2020215</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="13" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr> -->
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="infoTable">
            <span>Rows per page :</span>
            <div class="selects type03">
              <button type="button" class="off">10</button>
              <ul>
                <li><button type="button">10</button></li>
              </ul>
            </div>
            <span>1-5 of 999</span>
            <div class="btns">
              <button type="button" class="prev"><img src="/images/arrow.png" alt=""></button>
              <button type="button"><img src="/images/arrow.png" alt=""></button>
            </div>
          </div>
        </div>

        <!-- developer user case -->
        <div class="tableWrap">
          <div class="titArea">
            <h3 class="tit">Detail Information</h3>
            <div class="table-filter">
              <div class="filter-item short">
                <span class="title">Search by</span>
                <a href="#;" class="selected-text"><span>All</span></a>
                <!-- 토글 시 .active 클래스 추가 -->
                <div class="dropdown-wrap">
                  <ul>
                    <li><a href="#;">All</a></li>
                    <li><a href="#;">Issue No.</a></li>
                    <li><a href="#;">App Version</a></li>
                    <li><a href="#;">OS</a></li>
                    <li><a href="#;">Report and Guide</a></li>
                    <li><a href="#;">Symptom</a></li>
                    <li><a href="#;">Last Comment</a></li>
                    <li><a href="#;">Last Modified</a></li>
                  </ul>
                </div>
              </div>
              <div class="filter-item">
                <span class="title">Search</span>
                <div class="input-text search">
                  <input type="text" name="" id="" value="" placeholder="Search"><button type="button"><img src="/images/btn_close.png" alt=""></button>
                </div>
              </div>
              <div class="alignRight">
                <div class="filter-item">
                  <span class="title">Last Modified</span>
                  <div class="picker-wrap">
                    <date-picker :editable="false" v-model="time2" type="date" range :format="format" @change="toggleFooter" @open="open" @close="close" ref="datepicker1" :lang="lang" placeholder="Select Datetime">
                      <template v-slot:header="{ emit }">
                        <button class="mx-btn mx-btn-text" @click="selectPrev7Day(emit)">Previous 7 Days</button>
                        <button class="mx-btn mx-btn-text" @click="selectPrev30Day(emit)">Previous 30 Days</button>
                        <button class="mx-btn mx-btn-text" @click="selectPrev60Day(emit)">Previous 60 Days</button>
                        <button class="mx-btn mx-btn-text" @click="selectPrev90Day(emit)">Previous 90 Days</button>
                      </template>
                      <template v-slot:footer="{  }">
                        <button class="mx-btn mx-btn-text" @click="handleApply">OK</button>
                      </template>
                      <i slot="icon-clear"><span class="clear-icon"><img src="/images/btn_close.png" alt=""></span></i>
                    </date-picker>
                  </div>
                </div>
                <button type="button" class="excel" data-pop="excel-pop">Export</button>
                <button type="button" class="column" data-pop="column-pop">Columns</button>
              </div>
            </div>
          </div>
          <div class="innerTable with-filter">
            <div class="scrollX">
              <div class="tableSt01">
                <table class="absolute">
                  <colgroup>
                    <col width="124px" />
                    <col width="96px" />
                    <col width="96px" />
                    <col width="96px" />
                    <col width="70px" />
                    <col width="190px" />
                    <col width="128px" />
                    <col width="140px" />
                    <col width="210px" />
                    <col width="128px" />
                    <col width="128px" />
                    <col width="40px" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Issue No.</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>App Version</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Model Name</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Model Version</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>OS</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Report and Guide</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Symptom</strong>
                            <div class="filter">
                              <button type="button"><span class="sr-only">filter</span></button>
                              <div class="dropdown-wrap">
                                <ul>
                                  <li><a href="#;">All</a></li>
                                  <li><a href="#;">FC/ANR</a></li>
                                  <li><a href="#;">Touch</a></li>
                                  <li><a href="#;">Sluggish</a></li>
                                  <li><a href="#;">Battery Consumption</a></li>
                                  <li><a href="#;">Function</a></li>
                                  <li><a href="#;">Foldable</a></li>
                                </ul>
                              </div>
                            </div>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Reported by</strong>
                            <div class="filter">
                              <button type="button"><span class="sr-only">filter</span></button>
                              <div class="dropdown-wrap">
                                <ul>
                                  <li><a href="#;">All</a></li>
                                  <li><a href="#;">App</a></li>
                                  <li><a href="#;">Me</a></li>
                                  <li><a href="#;">Samsung</a></li>
                                </ul>
                              </div>
                            </div>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Reported by (id)</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Last Comment</strong>
                            <div class="filter">
                              <button type="button"><span class="sr-only">filter</span></button>
                              <div class="dropdown-wrap">
                                <ul>
                                  <li><a href="#;">All</a></li>
                                  <li><a href="#;">App</a></li>
                                  <li><a href="#;">Samsung</a></li>
                                </ul>
                              </div>
                            </div>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="inbox">
                          <div class="str">
                            <strong>Last Modified</strong>
                            <button class="sort" type="button"><img src="/images/btn_sort.png" alt=""></button>
                          </div>
                        </div>
                      </th>
                      <th class="file">
                        <div class="inbox">
                          <div class="str">
                            <strong>File</strong>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </table>
                <div class="scroll">
                  <table>
                    <colgroup>
                      <col width="124px" />
                      <col width="96px" />
                      <col width="96px" />
                      <col width="96px" />
                      <col width="70px" />
                      <col width="190px" />
                      <col width="128px" />
                      <col width="140px" />
                      <col width="210px" />
                      <col width="128px" />
                      <col width="128px" />
                      <col width="40px" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="12" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="12" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="12" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="12" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="12" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="12" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="12" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="12" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="12" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div><p><a href="#">210825-00010</a></p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>A305N</p></div>
                        </td>
                        <td>
                          <div><p>XXXTB10</p></div>
                        </td>
                        <td>
                          <div><p>10</p></div>
                        </td>
                        <td>
                          <div>
                            <button type="button" class="openr"><img src="/images/icon_openr_off.png" alt=""> 09-21 06:35:23.943 10387.3.1585 2366...</button>
                          </div>
                        </td>
                        <td>
                          <div><p>Battery consumption</p></div>
                        </td>
                        <td>
                          <div><p>Me</p></div>
                        </td>
                        <td>
                          <div><p>abc@email.com</p></div>
                        </td>
                        <td>
                          <div><p>App</p></div>
                        </td>
                        <td>
                          <div><p>2021-05-09 06:30 PM </p></div>
                        </td>
                        <td class="center">
                          <div><button type="button" class="file"><img src="/images/btn_down.png" alt=""></button></div>
                        </td>
                      </tr>
                      <tr class="blues">
                        <td colspan="12" class="allTxt">
                          <div><p>09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus).</p></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="infoTable">
            <span>Rows per page :</span>
            <div class="selects type03">
              <button type="button" class="off">10</button>
              <ul>
                <li><button type="button">10</button></li>
              </ul>
            </div>
            <span>1-5 of 999</span>
            <div class="btns">
              <button type="button" class="prev"><img src="/images/arrow.png" alt=""></button>
              <button type="button"><img src="/images/arrow.png" alt=""></button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- /content-box -->

  </div>
</template>
<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

  export default {
    components: { DatePicker },
    data() {
      return {
        time1: null,
        time2: null,
        format: "YY-MM-DD",
        lang: {
          formatLocale: {
            weekdaysMin: ['S ', 'M', 'T ', 'W', 'T', 'F', 'S'],
          },
        },
        openpop : null
      };
    },
    methods: {
      selectPrev7Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 7 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      selectPrev30Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 30 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      selectPrev60Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 60 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      selectPrev90Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 90 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      toggleFooter (value, type) {
        if (type === 'date') {
          const footer = document.getElementsByClassName('mx-datepicker-footer')[0];
          footer.classList.add('on');
        }
      },
      open () {
        const filterBox = document.getElementsByClassName('mx-datepicker')[0];
        filterBox.classList.remove('active');
      },
      close () {
        const filterBox = document.getElementsByClassName('mx-datepicker')[0];
        filterBox.classList.remove('active');
      },
      handleApply () {
        this.$refs.datepicker.closePopup();
        this.$refs.datepicker1.closePopup();
      }
    },
  }
</script>
<style scoped>
/* common */
.sr-only { position: absolute; top: 0; left: 0; width: 0; height: 0; overflow: hidden; visibility: hidden; font-size: 0; line-height: 0; } 
/* /common */

/* =========== LAYOUT ========== */
.content-box { height: 100%; padding: 40px 24px 0; } 
.content-inner { max-width: 1000px; margin: auto; } 
@media all and (max-width: 1000px){
 .content-box { padding: 32px 24px 0; } 
 }

/* =========== COMPONENTS ========== */
.h2 { display: block; margin-top: 20px; font-family: SamsungSharpSans-Medium; font-size: 40px; font-weight: 500; line-height: 1.5; letter-spacing: -0.13px; color: #000; } 
.h3 { display: block; margin-top: 42px; padding: 22px 0; font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.1px; color: #000; font-family: SamsungSharpSans-Medium; } 
.chart-title { display: block; margin-top: 80px; font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.1px; color: #000; font-family: SamsungSharpSans-Medium; }
.chart-subtitle { display: block; margin-top: 48px; margin-bottom: 24px; font-size: 16px; font-weight: bold; line-height: 1.5; letter-spacing: -0.4px; color: #363636; }
.chart-caption { position: relative; display: block; margin-top: 24px; margin-bottom: 56px; font-family: Arial; font-size: 14px; line-height: 1.43; color: #363636; letter-spacing: -0.1px; }

@media all and (max-width: 1000px){
 .h2 { margin-top: 0; font-size: 36px; line-height: 1.22; letter-spacing: -0.1px; } 
 .h3 { margin-top: 26px;}
 .chart-subtitle { margin-top: 34px; }
 .chart-caption { margin: 16px 0 40px; }
 }
/* chart */
.chart-wrap { margin: 0 -24px; scrollbar-width: none; -ms-overflow-style: none; overflow-x: scroll; } 
.chart-wrap + .chart-wrap { margin-top: 24px; } 
.chart-wrap::-webkit-scrollbar { display: none; } 
.chart-wrap .chart-inner { width: 1048px; padding: 0 24px; } 
.chart { width: 100%; height: 100%; padding: 20px; border-radius: 4px; border: solid 1px #ebebed; scrollbar-width: none; -ms-overflow-style: none; overflow-x: scroll; } 
.chart::-webkit-scrollbar { display: none; } 
.chart-wrap .chart-img img { max-width: 100%; } 


.chart-radio { position: relative; margin: 20px 0; min-height: 160px;} 
.chart-radio-item { padding-left: 770px; } 
.chart-radio-item input { position: absolute; opacity: 0; cursor: pointer; height: 0; width: 0; } 
.chart-radio-item label .text { position: relative; display: block; padding-left: 26px; margin-top: 8px; white-space: nowrap; font-family: AppleSDGothicNeo; font-size: 10px; font-weight: bold; line-height: normal; color: #4a4a4a; } 
.chart-radio-item label .text:before { content: ""; position: absolute; left: 0; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; background: url(/images/radio-off.png) no-repeat center / cover; } 
.chart-radio-item input:checked + label .text:before { background-image: url(/images/radio-on.png); } 
.chart-radio-item label .color { display: inline-block; width: 34px; height: 5px; margin-right: 10px; } 
.chart-radio-item label .chart-img { display: none; position: absolute; top: 50%; left: 0; right: 208px; transform: translateY(-50%); } 
.chart-radio-item input:checked + label .chart-img { display: block; } 
/* /chart */
/* button */
.filled-btn { display: inline-block; width: 200px; padding: 15px 24px; border-radius: 4px; font-size: 16px; font-weight: bold; line-height: normal; text-align: center; color: #fff; background-color: #0f42cf; vertical-align: middle; font-family: SamsungOne; } 
.lined-btn { display: inline-block; width: 200px; padding: 15px 24px; border-radius: 4px; border: 1px solid #d6d6d6; font-size: 16px; font-weight: bold; line-height: normal; text-align: center; color: #363636; background-color: #fff; vertical-align: middle; font-family: SamsungOne;} 
.filled-btn:hover:not([disabled]) { background-color: #002ba3; } 
.lined-btn:hover:not([disabled]) { background-color: #d6d6d6; } 
/* /button */
/* checkbox */
.check-wrap { display: inline-block; margin: 5px 0; } 
.check-wrap input[type="checkbox"] { position: absolute; opacity: 0; cursor: pointer; height: 0; width: 0; } 
.check-wrap input[type="checkbox"] + label span { position: relative; display: inline-block; padding-left: 26px; padding-top: 2px; font-size: 16px; line-height: 1.25; letter-spacing: -0.11px; color: #363636; } 
.check-wrap input[type="checkbox"] + label span:before { content: ""; position: absolute; left: 0; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; background: url(/images/icon_checkbox.png) no-repeat center / cover; } 
.check-wrap input[type="checkbox"]:checked + label span:before { background-image: url(/images/icon_checkbox_on.png) !important; } 
/* /checkbox */

.right-wrap { margin-bottom: 16px; } 
.right-wrap:after { content: ""; display: block; clear: both; }
.right-wrap .check-wrap + .filled-btn { float: right; padding: 8px 24px; margin-left: 16px; font-size: 14px; } 
/* input */
.input-text { position: relative; padding: 0 12px; border-radius: 4px; border: solid 1px #d6d6d6; background-color: #fff; } 
.input-text.big { padding: 0 12px; } 
.input-text.search { padding-left: 32px; background: url(/images/input-search.png) no-repeat #fff 8px center / 16px 17px; } 
.input-text input[type="text"] { width: 100%; height: 30px; line-height: 20px; font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; font-size: 14px; color: #363636; } 
.input-text input[type="text"] + button { display: none; position: absolute; right: 8px; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; padding: 3px; line-height: 0; font-size: 0; } 
.input-text input[type="text"] + button img { max-width: 100%; } 
.input-text.active input[type="text"] + button { display: block; } 
.input-text.active.error input[type="text"] + button { display: none; } 
.input-text.active { padding-right: 32px; } 
.input-text.big input[type="text"] { height: 46px; font-size: 16px; line-height: 1.38; } 
.input-text.active { border-color: #0f42cf; } 
.input-text.error { border-color: #ec2000; padding-right: 36px; background: url(/images/error.png) no-repeat #fff calc(100% - 9px) center / 16px; } 
.input-text.big.error { padding-right: 48px; background-size: 24px; } 
.error-msg { display: none; font-family: SamsungOne; font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #ec2000; }
.input-text.error + .error-msg { display: block; }
.comment-wrap .error-msg { padding-left: 85px; margin-top: 8px; }
.input-file { position: relative; border-radius: 4px; border: solid 1px #d6d6d6; } 
.input-file input[type="file"] { position: absolute; opacity: 0; cursor: pointer; height: 0; width: 0; } 
.input-file input[type="file"] + label { display: block; width: 32px; height: 32px; font-size: 0; line-height: 0; background: url(/images/attachment.png) no-repeat center transparent; background-size: 16px; cursor: pointer; } 
.textarea { width: 100%; height: 100px; font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #363636; resize: none; scrollbar-width: none; -ms-overflow-style: none; overflow-x: scroll; } 
.textarea::-webkit-scrollbar { display: none; } 
/* /input */
.comment-wrap { position: relative; padding: 24px 16px 16px; border-radius: 4px; background-color: #f7f7f7; } 
.comment-wrap .comment-head { position: relative; } 
.comment-head .issue-info { margin-right: 64px; } 
.comment-head .issue-info .no { display: inline-block; margin-right: 8px; margin-bottom: 8px; font-size: 16px; line-height: 1; letter-spacing: -0.11px; color: #6e6e6e; vertical-align: middle; } 
.comment-head .issue-info .input-text { display: inline-block; width: 200px; vertical-align: middle; margin-bottom: 8px; } 
.comment-head .input-file { position: absolute; top: 0; right: 0; } 
.comment-wrap .comment { position: relative; padding: 16px 16px 36px; border-radius: 4px; border: solid 1px #d6d6d6; background-color: #fff; } 
.comment-bottom { margin-top: 8px; font-size: 0; line-height: 0; } 
.comment.error { border-color: #ec2000; } 
.comment-wrap .error-msg { font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #ec2000; display: none; padding-left: 8px; margin-top: 8px; }
.comment.error + .error-msg { display: block; } 
.comment-bottom:after { content: ""; display: block; clear: both; } 
.comment-bottom .attached { position: relative; display: inline-block; padding: 13px 48px 13px 8px; border-radius: 4px; border: solid 1px #d6d6d6; } 
.comment-bottom .attached .name { display: inline-block; padding-left: 24px; font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #6e6e6e; background: url(/images/file.png) no-repeat left center; background-size: 16px; } 
.comment-bottom .attached .delete-btn { position: absolute; top: 50%; right: 8px; transform: translateY(-50%); width: 16px; height: 16px; background: url(/images/close-light.png) no-repeat center / cover; } 
.comment-bottom .apply-btn { float: right; width: 120px; margin-top: 8px; padding: 7px 24px; border-radius: 4px; border: solid 1px #d6d6d6; font-size: 14px; font-weight: bold; line-height: normal; color: #363636; font-family: SamsungOne;} 
.comment-bottom .apply-btn:hover:not([disabled]) { background-color: #d6d6d6; } 
.comment-wrap .comment .count { position: absolute; bottom: 8px; right: 12px; font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #9e9e9e; }
.comment-wrap .comment.active .count .cur { color: #363636; }

.table-filter { position: relative; margin-top: 40px; }
.filter-item { position: relative; width: 200px; display: inline-block; vertical-align: top; } 
.filter-item.short { width: 160px; }
.filter-item + .filter-item { margin-left: 8px; }
.filter-item .title { display: block; margin-bottom: 6px; font-size: 14px; font-weight: bold; line-height: 1.43; letter-spacing: -0.14px; color: #6e6e6e; } 
.filter-item .input-text.active + .dropdown-wrap { display: block; } 
.filter-item .selected-text { position: relative; display: block; padding: 5px 36px 5px 12px; border-radius: 4px; border: solid 1px #d6d6d6; font-size: 14px; line-height: 1.43; color: #363636; } 
.filter-item .selected-text:before { content: ""; position: absolute; top: 50%; right: 12px; transform: translateY(-50%); width: 16px; height: 16px; background: url(/images/arrow-light.png) no-repeat center / cover; } 
.filter-item .selected-text.active { border-color: #0f42cf; } 
.filter-item .selected-text.active:before { transform: translateY(-50%) rotate(180deg); } 
.filter-item .selected-text span { display: block; max-width: 100%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; } 
.filter-item .selected-text.active + .dropdown-wrap { display: block; } 
.dropdown-wrap { display: none; position: absolute; top: calc(100% + 4px); left: 0; right: 0; background-color: #fff; z-index: 20; padding: 8px 0; border-radius: 4px; border: solid 1px #d6d6d6; max-height: 378px; overflow: auto; } 
.dropdown-wrap ul { display: block; margin: 0; } 
.dropdown-wrap ul li { flex: none; width: 100%; padding: 0; } 
.dropdown-wrap ul li a { display: block; padding: 10px 12px; color: #363636; font-size: 14px; line-height: 1.43; } 
.dropdown-wrap ul li button { display: block; padding: 10px 12px; color: #363636; font-size: 14px; line-height: 1.43; width: 100%; text-align: left; font-family: SamsungOne; } 
.dropdown-wrap ul li.recent a { padding-left: 40px; background: url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
.dropdown-wrap ul li:hover a { background-color: rgba(15,66,207,0.1); } 
.dropdown-wrap ul li:hover button { background-color: rgba(15,66,207,0.1); } 

@media all and (max-width: 1000px){
  .right-wrap .check-wrap + .filled-btn { display: block; width: 100%; margin-left: 0; margin-top: 16px; padding: 10px 24px; font-size: 16px; }

 .comment-bottom .attached { display: block; } 
 .comment-bottom .attached + .apply-btn { margin-top: 16px; }
.comment-head .issue-info .input-text { width: 160px; padding-top: 0; padding-bottom: 0; height: 42px; }
.comment-head .issue-info .input-text input[type="text"] {height: 40px;}
.input-file input[type="file"] + label { width: 40px; height: 40px; background-size: 24px; } 
.comment-bottom .apply-btn { padding: 10px 24px; font-size: 16px; }

 .filter-item { display: block; width: 100%; }
 .filter-item.short { width: 100%; }
 .filter-item + .filter-item { margin-left: 0; margin-top: 16px; }
 .input-text { padding-top: 0; padding-bottom: 0; }
.input-text input[type="text"] {height: 40px;}
 .input-text.active { padding-right: 36px; }
 .input-text.search { padding-left: 36px; background-position: 12px center; }
 .input-text input[type="text"] + button { right: 12px; }
 .filter-item .selected-text { padding-top: 9px; padding-bottom: 9px; font-size: 16px; } 
}


 /* datetimepicker */
.mx-datepicker-range {width: 100%; } 
.mx-datepicker >>> .mx-input {max-width: 100%; height: 32px;padding: 6px 56px 6px 12px; border-color: #d6d6d6;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #000; font-family: SamsungOne;background: #ffffff url(/images/ic-calendar.png) calc(100% - 12px) center no-repeat;background-size: 16px; box-shadow: none; } 
.mx-datepicker >>> .mx-input:hover {border-color: #d6d6d6; } 
.mx-datepicker >>> .mx-input:focus {border-color: #0f42cf; } 
.mx-datepicker >>> .mx-input::placeholder {font-weight: normal !important; } 
.mx-datepicker >>> .mx-icon-calendar {display: none; } 
.picker-wrap >>> .mx-icon-clear {right: 36px; font-size: 0; }
.clear-icon {display: block;width: 16px;height: 16px; }  
.mx-datepicker >>> .calendar-icon {display: block;width: 24px;height: 24px; } 
.mx-datepicker >>> .calendar-icon img, .clear-icon img { width: 100%; } 
.mx-datepicker.active .calendar-icon { opacity: 1; } 
.mx-icon-left:before, .mx-icon-right:before, .mx-icon-double-left:before, .mx-icon-double-right:before, .mx-icon-double-left:after, .mx-icon-double-right:after {width: 14px;height: 14px;margin-left: -4px;border-width: 3px 0 0 3px;border-color: #000; } 
.mx-calendar-panel-month .mx-icon-left:after, .mx-calendar-panel-month .mx-icon-right:after, .mx-calendar-panel-month .mx-icon-double-left:after, .mx-calendar-panel-month .mx-icon-double-right:after {display: none; } 
.mx-calendar-panel-year .mx-icon-left:after, .mx-calendar-panel-year .mx-icon-right:after, .mx-calendar-panel-year .mx-icon-double-left:after, .mx-calendar-panel-year .mx-icon-double-right:after {display: none; } 
.picker-wrap >>> .mx-input-wrapper .mx-icon-clear{display:block}


/* calendar */
.mx-datepicker-main {border-radius: 4px; } 
.mx-datepicker-header {padding: 12px 0;border-color: #ebebed; } 
.mx-datepicker-header .mx-btn { margin: 0 7px;padding: 2px 8px; border-radius: 4px;font-size: 12px; line-height: 1.67; letter-spacing: -0.12px; color: rgba(54,54,54,0.8);font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-datepicker-header .mx-btn:first-child {margin-left: 5px; } 
.mx-datepicker-header .mx-btn:hover { background-color: rgba(15,66,207,0.1); } 
.mx-datepicker-footer {display: none;padding: 12px 16px; } 
.mx-datepicker-footer.on {display: block; } 
.mx-datepicker-footer .mx-btn {padding: 5px 16px 4px; border-radius: 4px; border: solid 1px #0f42cf;color: #0f42cf;font-weight: bold;font-size: 12px;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif;line-height: normal; } 
.mx-calendar {padding: 0 16px 32px; } 

/* header, footer */
.mx-calendar-header, .mx-time-header {margin-top: 16px;height: 36px;line-height: 36px; } 
.mx-calendar-header-label .mx-btn,
.mx-time-header .mx-btn,
.mx-calendar-header-label {font-size: 16px;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif;font-weight: bold;color: #363636; } 
.mx-table th {font-size: 12px;font-weight: normal; color: #d6d6d6; } 
.mx-table-date td {color: #363636;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-table-date .cell.not-current-month {color: #d6d6d6; } 
.mx-table-date .today {color: #0f42cf; } 
.mx-calendar-content .cell.active {border-radius: 4px;background-color: #0f42cf; } 
.mx-calendar-content .cell.in-range,
.mx-calendar-content .cell.hover-in-range,
.mx-calendar-content .cell:not(.active):hover {background-color: rgba(15,66,207,0.1); } 

/* time */
.mx-time-content {padding: 0 26px; } 
.mx-time-header {border: none; } 
.mx-time-column {margin: 0 5px;border: none; } 
.mx-time-column .mx-time-item {height: 24px;line-height: 24px;border-radius: 4px;color: #363636;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-time-column .mx-time-item:hover {background-color: rgba(15,66,207,0.1); } 
.mx-time-column .mx-time-item.active {color: #fff;font-weight: normal;background-color: #0f42cf; } 
.mx-time-column .mx-time-list::after {display: none; } 

/* month, year */
.mx-calendar-panel-month,
.mx-calendar-panel-year {padding: 0 36px; } 
.mx-calendar-panel-month .mx-calendar-header, .mx-time-header,
.mx-calendar-panel-year .mx-calendar-header, .mx-time-header {margin: 16px -20px 0; } 
.mx-table.mx-table-month {height: 180px; } 
.mx-table-month .cell,
.mx-table-year .cell {padding: 0 4px;color: #363636;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-table-month .cell div,
.mx-table-year .cell div {padding: 5px;border-radius: 4px; } 
.mx-table-month .cell.active,
.mx-table-year .cell.active {background-color: transparent; } 
.mx-table-month .cell.active div,
.mx-table-year .cell.active div {padding: 5px 0;border-radius: 4px;background-color: #0f42cf; } 
.mx-table-month .cell:not(.active):hover,
.mx-table-year .cell:not(.active):hover {background-color: transparent;color: #363636; } 
.mx-table-month .cell:not(.active):hover div,
.mx-table-year .cell:not(.active):hover div {background-color: rgba(15,66,207,0.1); } 
/* /datetimepicker */
@media all and (max-width:1000px){
 .input-text-wrap .text { display: block; margin-right: 0; margin-bottom: 8px; padding-right: 0; } 
 .input-text-wrap .text:before { display: none; } 
 .input-text-wrap .picker-wrap { width: 100%; } 
 .mx-calendar,
 .mx-time { width: 100%; } 
 .mx-datepicker-popup { max-height: 80vh; overflow-x: auto; } 
 .input-text-wrap .select-wrap { width: 100%; } 

 .mx-datepicker { margin-bottom: 16px; }
 .mx-datepicker >>> .mx-input { height: 42px; padding: 6px 84px 6px 16px; background-position: calc(100% - 16px) center; background-size: 24px; } 
 .picker-wrap >>> .mx-icon-clear {right: 52px; }
 .clear-icon { width: 24px;height: 24px; } 
}


/* ============== table ============== */
.tableWrap { position: relative; width:100%; max-width:1000px; margin-top:40px; } 
.tableWrap .titArea { position: relative; padding:24px 0 16px; min-height: 68px; } 
.tableWrap .titArea .tit { font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.1px; color: #000; font-family: SamsungSharpSans-Medium; } 
.tableWrap .titArea .alignRight { position: absolute; right:0; bottom: 0; display:flex; align-items: flex-end; } 
.tableWrap .titArea .alignRight .excel { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap .titArea .alignRight .column { margin-left:8px; width: 120px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap .titArea .alignRight .del { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap .titArea .alignRight .edit { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap .titArea .alignRight .add { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap.titOn { } 
.tableWrap.titOn .titArea { z-index:20; } 
.tableWrap.titOn .tableSt01 { z-index:10; } 
.tableSt01 { } 
.tableSt01.headOn > table { z-index:10; } 
.tableSt01.headOn > .scroll { position: relative; z-index:9; } 
.tableSt01 table { table-layout: fixed;position: relative; } 
.tableSt01 thead th { position: relative;  background:#f7f7f7; border-bottom:1px solid #ebebed; text-align:left; } 
.tableSt01 thead th .inbox { position: relative; padding:12px 32px 12px 16px; } 
.tableSt01 thead th.file .inbox { padding: 12px 8px; } 
.tableSt01 thead th .inbox::after { content:''; width:1px; height:32px; position: absolute; right:0; top:50%; transform: translateY(-50%); background:#ebebed; } 
.tableSt01 thead tr th:last-child .inbox::after { display:none; } 
/* .innerTable.with-filter .tableSt01 thead th.file:before { content: ""; position: absolute; top: 0; right: -30px; bottom: 0; left: 0; background-color: #f7f7f7; z-index: -1; } */
.tableSt01 thead th .str { font-size: 0; line-height: 0; } 
.innerTable.summary .tableSt01 thead th .str { min-height: 100%; } 
.tableSt01 thead th .str > strong { display: inline-block; font-size: 13px; font-weight: bold; line-height: 1.23; letter-spacing: -0.13px; color: #363636; } 
.tableSt01 thead th .str .sort { position: absolute; top: 50%; right: 8px; transform: translateY(-50%); width: 16px; font-size: 0; line-height: 0; } 
.tableSt01 thead th .str button img { width:100%; } 
.tableSt01 thead th .str .filter { position: absolute; top:50%; transform: translateY(-50%); right: 28px; font-weight: normal; font-size: 0; line-height: 0; } 
.tableSt01 thead th .str .filter button { width:16px; height: 16px; background: url(/images/filter.png) no-repeat center / cover; } 
.tableSt01 thead th .str .filter.active button { background-image: url(/images/filter-active.png); } 
.tableSt01 thead th .str .filter.active .dropdown-wrap { display: block; width: 160px; top: calc(100% + 24px); left: auto; right: -28px; } 
.tableSt01 thead th.center { text-align:center; } 
.tableSt01 thead th.center .inbox { padding:0; justify-content: center; display: flex; align-items: center; } .tableSt01 thead .only th .inbox { padding: 20px 8px 20px 16px; }
.tableSt01 thead .only th .inbox::after { height:32px; } 
.fileFlus { position: absolute; top:154px; right:-10px; z-index:30;} 
.fileFlus > button img { width:24px; } 
.fileFlus.curr .absList { display:block; z-index:20; } 
.fileFlus .absList { position: absolute; right:0; top:100%; width:214px; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); background:#fff; display:none; } 
.fileFlus .absList .all { margin: 0 8px; padding:10px 0; border-bottom:1px solid #ebebed; } 
.fileFlus .absList ul { padding-top:8px; } 
.fileFlus .absList li { padding:10px 8px; } 
.fileFlus .absList li:hover { background:#e6ecfb; } 
.fileFlus .absList label { font-family: SamsungOne; font-size: 14px; font-weight:normal; line-height: 1.43; color: #363636; margin-left:8px; } 
.fileFlus .absList .btns { padding:8px 8px 0; display: flex; justify-content: space-between; margin-top:8px; } 
.fileFlus .absList .btns button { width:calc(50% - 4px); height: 32px; border-radius: 4px; } 
.fileFlus .absList .btns button.btnOk { font-size: 14px; font-weight: bold; letter-spacing: -0.14px; color: #ffffff; background-color: #0f42cf; } 
.fileFlus .absList .btns button.btnRe { font-size: 14px; font-weight: bold; color: #363636; background-color: #fff; border: solid 1px #d6d6d6; } 
.tableSt01 thead th .picker-wrap {display: block; width: 100%; margin-top: 10px;}
.tableSt01 thead th .mx-datepicker-range {width: 100%;}
.tableSt01 thead th >>> .mx-datepicker .mx-icon-calendar { display: none;}
.tableSt01 thead th >>> .mx-datepicker .mx-icon-clear {right: 26px; }
.tableSt01 thead th >>> .mx-input {height: 24px; border-color: #d6d6d6;background: #ffffff url(/images/ic-calendar.png) calc(100% - 8px) center no-repeat;background-size: 12px;padding: 0 48px 0 8px; font-family: SamsungOne; font-size: 13px; line-height: 1.54; letter-spacing: normal; box-shadow: none; max-width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; color: #000;}
.tableSt01 thead th .clear-icon {width: 10px;height: 10px; }

.tableSt01 tbody td { border-bottom:1px solid #ebebed; text-align:left; vertical-align: middle; } 
.tableSt01 tbody td.center { text-align:center; } 
.tableSt01 tbody td.middle { vertical-align: middle; } 
.tableSt01 tbody td.ellipsis p { max-width: 100%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; } 

.innerTable.with-filter .tableSt01 tbody .blues {display: none;}
.innerTable.with-filter .tableSt01 tbody .blues.curr {display: table-row;}
.innerTable.summary .tableSt01 tbody .blues {display: none;}
.innerTable.summary .tableSt01 tbody .blues.curr {display: table-row;}
.tableSt01 tbody .blues {display: table-row;}
.tableSt01 tbody .blues.curr {display:table-row;}
.tableSt01 tbody .blues td { background-color: rgba(15, 66, 207, 0.03); } 
.tableSt01 tbody .blues td.removeBr { background-color:#fff; } 
.tableSt01 tbody .blues td.blue { background-color: rgba(15, 66, 207, 0.03); } 
.tableSt01 tbody td.removeBr { border-bottom:0; } 
.tableSt01 tbody td > div { padding:16px; } 
.tableSt01 tbody td > div .status { display: block; width: 88px; margin: auto; padding: 2px; border-radius: 4px; font-size: 12px; line-height: 1.67; letter-spacing: -0.17px; font-weight: bold; } 
.tableSt01 tbody td > div .status.complete { color: #52c51a; background-color: rgba(0,196,46,0.1); } 
.tableSt01 tbody td > div .status.progress { color: #faad14; background-color: rgba(255,187,0,0.1); } 
.tableSt01 tbody td.allTxt > div { padding:16px 16px 16px 24px; position: relative; } 
.tableSt01 tbody td.allTxt > div strong { display:block; font-family: SamsungOne; font-size: 14px; font-weight: bold; line-height: 1.43; letter-spacing: -0.14px; color: #6e6e6e; padding-bottom:8px; } 
.tableSt01 tbody td.allTxt > div .option { position: absolute; right:12px; top:18px; padding: 0; } 
.tableSt01 tbody td.allTxt > div .option.curr > button { background:#dde6fa; border-radius: 4PX; } 
.tableSt01 tbody td.allTxt > div .option.curr ul { display:block; } 
.tableSt01 tbody td.allTxt > div .option > button { width:24px; height:24px; border-radius: 4px; padding: 3px; } 
.tableSt01 tbody td.allTxt > div .option > button:hover { background-color: rgba(15, 66, 207, 0.1); } 
.tableSt01 tbody td.allTxt > div .option > button + button {  margin-left: 8px; }
.tableSt01 tbody td.allTxt > div .option > button img { width:16px; } 

.tableSt01 tbody td.allTxt > div .option ul { position: absolute; top:100%; right:0; width:140px; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); background:#fff; display:none; } 
.tableSt01 tbody td.allTxt > div .option ul button { width:100%; height:40px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; font-family: SamsungOne; } 
.tableSt01 tbody td.allTxt > div .option ul button:hover { background:#e6ecfb; } 
/* .tableSt01 tbody td .openr { padding:6px; } */
.tableSt01 tbody td .openr { position: relative; padding-left: 20px; display: none; font-size: 14px; line-height: 1.29; letter-spacing: -0.1px; color: #363636; font-family: Arial; text-align: left; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: 100%; } 
.innerTable.with-filter .tableSt01 tbody td .openr { display: block; } 
.innerTable.summary .tableSt01 tbody td .openr { display: block; margin: auto; padding-left: 0; } 
.innerTable.summary .tableSt01 tbody td .openr img { position: static; transform: none; margin-right: 0 } 
.innerTable.summary .tableSt01 tbody td .openr.open img { transform: rotate(180deg); } 
.tableSt01 tbody td .openr { margin-left: -4px; padding-left: 24px; }
.tableSt01 tbody td .openr img { width:16px; vertical-align: middle; margin-right:8px; position: absolute; top: 50%; left: 0; transform: translateY(-50%); } 
.tableSt01 tbody td .openr.open img { transform: translateY(-50%) rotate(180deg); } 
.tableSt01 tbody td .file { padding: 4px; font-size: 0; line-height: 0; border-radius: 3px; margin-left: -8px; } 
.tableSt01 tbody td .file:hover { background: rgba(15,66,207,0.1); }
.tableSt01 tbody td .file img { width:16px; } 
.tableSt01 tbody td > div p { line-height: 1.29; letter-spacing: -0.1px; color: #363636; font-family: Arial; } 
.tableSt01 tbody td .openr + p { vertical-align: top; display: inline-block; max-width: calc(100% - 24px); } 
.tableSt01 tbody tr.blues td > div p { padding-right: 64px; } 
.innerTable.summary .tableSt01 tbody tr.blues td > div p { padding-right: 0; } 
.tableSt01 tbody td > div p a { color:#0f42cf; letter-spacing: -0.14px; white-space: nowrap; } 
.tableSt01 tbody td > div p a:hover { text-decoration: underline; } 


.tableSt01 .scroll { max-height:257px; overflow-y:auto; } 
.innerTable.with-filter .tableSt01 .scroll { max-height:none; } 
.tableSt01 .scroll.long { max-height:478px; } 
.tableSt01 input[type=checkbox] { width:16px; height:16px; border:0; background:url(/images/icon_checkbox.png) no-repeat; margin:0; background-size:100%; } 
.tableSt01 input[type=checkbox]:checked { background:url(/images/icon_checkbox_on.png) no-repeat; margin:0; background-size:100%; } 
.tableSt01 .searchBox { margin-top:10px; position: relative; } 
.tableSt01 .searchBox .searchInput > span { display:block; position: relative; } 
.tableSt01 .searchBox .searchInput > span input[type=text] { border-radius: 4px; border: solid 1px #d6d6d6; background: #ffffff url(/images/icon_search.png) 8px center no-repeat; background-size:16px; height:24px; width:100%; padding:0 8px 0 28px; } 
.tableSt01 .searchBox .searchInput.curr > span input[type=text] { border-color: #0f42cf; } 
.tableSt01 .searchBox .searchInput.curr > span input[type=text] + button { display:block; } 
.tableSt01 .searchBox .searchInput > span button { position: absolute; right:8px; top:50%; transform: translateY(-50%); display:none; } 
.tableSt01 .searchBox .searchInput > span button img { width:10px; } 
.tableSt01 .searchBox .searchInput.curr .absWord { display:block; } 
.tableSt01 .searchBox .searchInput .absWord { position: absolute; left:0; top:28px; width:100%; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); z-index:20; background:#fff; display:none; } 
.tableSt01 .searchBox .searchInput .absWord li button { width:100%; height:36px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; } 
.tableSt01 .searchBox .searchInput .absWord li button strong { font-weight:bold; } 
.tableSt01 .searchBox .searchInput .absWord li.time button { padding-left:40px; background:url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
.tableSt01 .searchBox .searchInput .absWord li button:hover { background:#e6ecfb; } 
.tableSt01 .searchBox .searchInput .absWord li.time button:hover { background:#e6ecfb url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
.tableSt01 .searchBox .searchInput .absWord .btns { padding:8px 8px 8px; display: flex; justify-content: space-between; margin-top:8px; display:none; } 
.tableSt01 .searchBox .searchInput .absWord .btns button { width:calc(100% - 40px); height: 32px; border-radius: 4px; } 
.tableSt01 .searchBox .searchInput .absWord .btns button.btnOk { font-size: 14px; font-weight: bold; letter-spacing: -0.14px; color: #ffffff; background-color: #0f42cf; } 
.tableSt01 .searchBox .searchInput .absWord .btns button.imgRe { width:32px; } 
.tableSt01 .searchBox .searchInput .absWord .btns button.imgRe img { width:32px; } 
.tableSt01 .searchBox > button { display:none; } 

.infoTable { display:flex; justify-content:flex-end; align-items: center; padding:16px; box-sizing: content-box; } 
.infoTable span { font-size: 12px; line-height: 1.5; letter-spacing: -0.09px; color: #9e9e9e; } 
.infoTable > * { margin-left:8px; } 
.infoTable span:first-child { margin-left: 0; } 
.infoTable > .btns { margin: -8px -4px -8px 8px; padding-left:12px; position: relative; text-align: right; } 
.infoTable > .btns::before { content:''; position: absolute; left:0; top:50%; transform: translateY(-50%); width:1px; height:16px; background:#ebebed; } 
.infoTable > .btns button { margin: 4px; vertical-align: middle; line-height:0; background-color: #fff; border-radius: 4px; border: 1px solid #d6d6d6; padding: 3px; } 
.infoTable > .btns button img { width:16px; } 
.infoTable > .btns button.prev img { transform: rotate(180deg); opacity: 0.2; } 
.selects { position: relative; } 
.selects > button { border-radius: 4px; border: solid 1px #d6d6d6; background-color: #ffffff; } 
.selects.curr ul { display:block; } 
.selects > ul { position: absolute; top:100%; left:0; width:100%; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); display:none; background-color: #fff; margin-top: 4px; } 
.selects > ul button { width:100%; height:36px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; } 
.selects > ul button:hover { background:#e6ecfb; } 

.selects .absList { position: absolute; background:#fff; right:0; top:100%; width:100%; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); background:#fff; display:none; z-index: 10; } 
.selects.curr .absList { display:block; } 
.selects .absList .all { margin: 0 8px; padding:10px 0; border-bottom:1px solid #ebebed; } 
.selects .absList ul { padding-top:8px; } 
.selects .absList li { padding:10px 8px; } 
.selects .absList li:hover { background:#e6ecfb; } 
.selects .absList label { font-family: SamsungOne; font-size: 14px; font-weight:normal; line-height: 1.43; color: #363636; margin-left:8px; } 
.selects .absList .btns { padding:8px 8px 0; display: flex; justify-content: space-between; margin-top:8px; } 
.selects .absList .btns button { width:calc(50% - 4px); height: 32px; border-radius: 4px; font-family: SamsungOne; } 
.selects .absList .btns button.btnOk { font-size: 14px; font-weight: bold; letter-spacing: -0.14px; color: #ffffff; background-color: #0f42cf; } 
.selects .absList .btns button.btnRe { font-size: 14px; font-weight: bold; color: #363636; background-color: #fff; border: solid 1px #d6d6d6; } 

.selects.type02 > button { width: 100%; padding:0 36px 0 12px; position: relative; font-family: SamsungOne; font-size: 13px; line-height: 1.54; letter-spacing: normal; color: #363636; height:32px; text-align:left; } 
.selects.type02 > button::after { content:''; position: absolute; right:12px; top:50%; transform: translateY(-50%); width:16px; height:16px; background:url(/images/arrow-light.png) no-repeat; background-size:100%; } 
.selects.type02 > button.active::after { transform: translateY(-50%) rotate(180deg); }
.selects.type03 > button { width: 80px; padding:0 28px 0 8px; position: relative; font-family: SamsungOne; font-size: 13px; line-height: 1.54; letter-spacing: normal; color: #363636; height:24px; text-align:left; } 
.selects.type03 > button::after { content:''; position: absolute; right:8px; top:50%; transform: translateY(-50%); width:12px; height:12px; background:url(/images/icon_openr_off.png) no-repeat; background-size:100%; } 
.selects.type03 ul button { width:100%; height:40px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 12px; font-family: SamsungOne; } 
.selects > button.off { color: #9e9e9e; } 


.tabSt01 { } 
.tabSt01 ul { display:flex; align-items: center; position: relative; } 
.tabSt01 ul::before { content:''; position: absolute; left:0; bottom:0; background:#d6d6d6; width:100%; height:2px; z-index: -1; } 
.tabSt01 ul button { height:52px; font-size: 16px; line-height: 1.5; color: #9e9e9e; padding:0 24px; text-transform: uppercase; font-family: SamsungOne; } 
.tabSt01 ul .curr button { color:#363636; border-bottom:2px solid #000; font-weight: bold; letter-spacing: -0.16px; } 


.sortable-table { overflow: hidden; padding-bottom: 170px;}
 .innerTable { width:100%; overflow-x:auto; } 
  .innerTable.with-filter { position: relative; overflow:visible; } 
  .tableSt01 .absolute { position: relative; top: 0; left: 0; z-index: 10; }
  .innerTable .scrollX { width:1000px; } 
  .innerTable.with-filter .scrollX {width: 100%;}
@media all and (max-width:1000px){
 .tableSt01 thead .only th .inbox { padding-right:8px; } 
 .tableSt01 thead .only th .inbox .str { width: 100%; } 
 .innerTable.summary .tableSt01 thead .only th .inbox .str { display: block; } 
 .tableSt01 .searchBox { margin-top:0px; position: static; } 
 .tableSt01 .searchBox .searchInput { display:none; } 
 .tableSt01 .searchBox .searchInput > span { display:block; position: relative; } 
 .tableSt01 .searchBox .searchInput > span input[type=text] { border-radius: 4px; border: solid 1px #d6d6d6; background: #ffffff url(/images/icon_search.png) 8px center no-repeat; background-size:16px; height:24px; width:100%; padding:0 8px 0 28px; } 
 .tableSt01 .searchBox .searchInput.curr > span input[type=text] { border-color: #0f42cf; } 
.tableSt01 .searchBox .searchInput.curr > span input[type=text] + button { display:block; } 
 .tableSt01 .searchBox .searchInput > span button { position: absolute; right:8px; top:50%; transform: translateY(-50%); display:none; } 
 .tableSt01 .searchBox .searchInput > span button img { width:10px; } 
 .tableSt01 .searchBox .searchInput.curr .absWord { display:block; } 
 .tableSt01 .searchBox .searchInput .absWord { position: absolute; left:0; top:28px; width:100%; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); z-index:20; background:#fff; display:none; } 
 .tableSt01 .searchBox .searchInput .absWord li button { width:100%; height:36px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; } 
 .tableSt01 .searchBox .searchInput .absWord li button strong { font-weight:bold; } 
 .tableSt01 .searchBox .searchInput .absWord li.time button { padding-left:40px; background:url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
 .tableSt01 .searchBox .searchInput .absWord li button:hover { background:#e6ecfb; } 
 .tableSt01 .searchBox .searchInput .absWord li.time button:hover { background:#e6ecfb url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
 .tableSt01 .searchBox .searchInput .absWord .btns { display:block; display:flex; } 
 .tableSt01 .searchBox > button { display:block; position: absolute; right:8px; top:50%; transform: translateY(-50%); font-size:0; line-height:0; width:16px; height:16px; background:url(/images/icon_search.png) no-repeat; background-size:100%; } 
 .tableSt01 .curr .searchBox > button { background:url(/images/icon_search_on.png) no-repeat; background-size:100%; } 
 .tableSt01 .curr .searchBox .searchInput { display:block; position: absolute; right:8px; top:45px; width:150%; } 
 .tableSt01 .curr .searchBox .searchInput > span input[type=text] { height:40px; } 
 .tableSt01 .curr .searchBox .searchInput .absWord { display:block; top:44px; } 
 .tableSt01 thead th.file .inbox { padding-bottom: 15px; }
 .tableSt01 thead th.file .str { justify-content: initial; }
.tableSt01 thead th .picker-wrap { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); width: 16px; margin-top: 0; }
.tableSt01 thead th >>> .mx-input { height: 0; padding: 8px; width: 0; border: none; background-color: transparent; background-position: right center; cursor: pointer; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; background-size: 16px;}
 .fileFlus { top: 234px; }

 
 .infoTable { background-color: #f7f7f7; } 
 .infoTable > * { margin-left:8px; } 

.tableWrap .titArea { min-height: 40px; padding-top: 8px; }
 .tableWrap .titArea .tit { font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.1px; color: #000; font-family: SamsungSharpSans-Medium; } 
 .tableWrap .titArea .alignRight { position: static; transform: translateY(0%); display:block; margin-top: 16px; } 
 .tableWrap .titArea .alignRight .selects { display:inline-block; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight .selects button { width:calc(100%) !important; height:40px; } 
 .tableWrap .titArea .alignRight .selects + .excel { width:calc(50% - 4px); height:40px; } 
 .tableWrap .titArea .alignRight .excel { display: inline-block; width: calc(50% - 4px); margin-left: 0; height: 40px; font-size: 16px; } 
 .tableWrap .titArea .alignRight .column { display: inline-block; width: calc(50% - 4px); margin-left: 8px; height: 40px; font-size: 16px; } 
 .tableWrap .titArea .alignRight .del { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
 .tableWrap .titArea .alignRight.basic .selects { display:block; width:100%; } 
 .tableWrap .titArea .alignRight.basic .del { margin-left:0; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic .edit { margin-left:0; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic .add { margin-left:0; margin-right: 8px; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic .edit + .del { margin-left: 8px; } 
 .tableWrap .titArea .alignRight.basic .excel { margin-left:8px; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic.only button { margin-left:0; height:40px; margin-top:0; width:100%; } 
 .tableWrap .titArea .alignRight.basic button:nth-child(3) { margin-left:0; margin-top: 8px; width: 100%; } 
 .tableWrap .titArea .alignRight.basic.even button { width: calc(33.33% - 8px) !important; margin: 0 4px !important; } 
 .tableWrap .titArea .alignRight.basic.even { margin: 22px -4px 0; } 
 .tableSt01 tbody td .openr { display: inline-block; }
 .tableSt01 tbody .blues { display: none; }
.tableSt01 tbody td.allTxt > div .option { right: 19px; top: 16px; }
.tableSt01 tbody td.allTxt > div .option > button { border: 1px solid #d6d6d6; }
.selects.type03 > button { width: 72px; height: 32px; } 
.infoTable > .btns button { padding: 7px; }
.infoTable > .btns { margin-left: 8px; }
.selects.type02 > button { height: 40px; font-size: 16px; }
.selects .absList label { font-size: 16px; }
 }
</style>